module.exports = __webpack_public_path__ + "img/talron-whatsapp.6927fef1.svg";